// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"dc621067","16":"247d542b","70":"1939ab24","164":"dc72773b","208":"0f7d3282","367":"7901c132","437":"74635fc4","536":"63f87c48","694":"311d76ac","722":"8d25133a","825":"0e761810","903":"141f8697","935":"1d33861c","952":"077cabef"}[chunkId] + ".chunk.js";
};